export const transformPlaceholder = (text) => {
  return text
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (char, index) => index === 0 ? char.toUpperCase() : char.toLowerCase());
};
